const ACCESS_TOKEN_KEY = 'access_token';

export const saveAccessToken = (value: string) => localStorage.setItem(ACCESS_TOKEN_KEY, value);
export const getAccessToken = () => localStorage.getItem(ACCESS_TOKEN_KEY);
export const clearAccessToken = () => localStorage.removeItem(ACCESS_TOKEN_KEY);



// WEBPACK FOOTER //
// ./src/services/tokenPersistence.ts